import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

//  ##      ##  ##     ##  #####
//  ##      ##  ####   ##  ##
//  ##      ##  ##  ## ##  #####
//  ##      ##  ##    ###  ##
//  ######  ##  ##     ##  #####

let pcSliderGroup = []
const pcSliderItem = document.getElementsByClassName('js-pcLineup')
if (pcSliderItem[0]) {
  // PC時だけスライダーにする
  if (window.matchMedia('(min-width:769px)').matches) {
    for (const targetSlider of pcSliderItem) {
      const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
      spSliderInit(targetSlider, sliderName)
    }
  }
  window.addEventListener('resize', function (e) {
    if (window.matchMedia('(max-width:768px)').matches) {
      for (const targetSlider of pcSliderItem) {
        const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
        if (pcSliderGroup[sliderName]) {
          // スライドが定義されていれば破棄
          pcSliderGroup[sliderName].destroy()
          pcSliderGroup[sliderName] = false
        }
      }
    } else if (window.matchMedia('(min-width:769px)').matches) {
      for (const targetSlider of pcSliderItem) {
        const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
        if (!pcSliderGroup[sliderName]) {
          // スライドが未定義なら初期化
          spSliderInit(targetSlider, sliderName)
        }
      }
    }
  })
}
function spSliderInit(targetSlider, sliderName) {
  pcSliderGroup[sliderName] = new Swiper(targetSlider, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
    spaceBetween: 20, //スライド同士の間隔を空ける

    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
  })
}
